import React, {useEffect, useState} from "react";
import PageTitle from "../../../components/common/page-title/PageTitle";
import {Link} from "react-router-dom";
import PrimaryButton from "../../../components/common/buttons/PrimaryButton";
import {FiPlus} from "react-icons/fi";
import VideoCategory from "../../../classes/VideoCategory";
import CategoriesTable from "../../../components/tables/CategoriesTable";

const VideosCategories = () => {

    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {

        let isMounted = true;
        const controller = new AbortController();

        const fetchVideosCategories = async () => {
            try {
                const results = await VideoCategory.getQuery().find();
                if (isMounted) {
                    setItems(results);
                }
            }
            catch (error) {
                console.error(error);
            }
            finally {
                if (isMounted) {
                    setLoading(false);
                }
            }
        }

        fetchVideosCategories();

        return () => {
            isMounted = false;
            controller.abort();
        }

    }, []);

    return (
        <div>
            <PageTitle title="Videos categories">
                <Link to="./new">
                    <PrimaryButton title="New video category" icon={<FiPlus/>}/>
                </Link>
            </PageTitle>
            <CategoriesTable items={items} loading={loading} />
        </div>
    );
};

export default VideosCategories;